import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const RECENT_PURCHASES = [{
  name: 'María L.',
  city: 'Córdoba'
}, {
  name: 'Fernando R.',
  city: 'Buenos Aires'
}, {
  name: 'Carla P.',
  city: 'Mendoza'
}, {
  name: 'Silvia G.',
  city: 'Rosario'
}, {
  name: 'Juan M.',
  city: 'La Plata'
}, {
  name: 'Andrea S.',
  city: 'Tucumán'
}, {
  name: 'Patricia D.',
  city: 'Neuquén'
}];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(RECENT_PURCHASES[0]);
  useEffect(() => {
    // Show first popup after 5 seconds
    const initialTimeout = setTimeout(() => {
      setVisible(true);
    }, 5000);
    // Cycle popups every 20 seconds
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        const randomPurchase = RECENT_PURCHASES[Math.floor(Math.random() * RECENT_PURCHASES.length)];
        setCurrentPurchase(randomPurchase);
        setVisible(true);
      }, 2000); // Wait 2s before showing next one
    }, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-40 max-w-sm w-full animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-6">
      <div className="bg-white rounded-lg shadow-2xl border-l-4 border-green-500 p-4 flex items-start gap-3 relative" data-id="element-7">
        <button onClick={() => setVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600" data-id="element-8">
          <X className="w-4 h-4" data-id="element-9" />
        </button>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-10">
          <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-11" />
        </div>

        <div data-id="element-12">
          <p className="text-sm font-bold text-gray-900" data-id="element-13">
            ¡Nueva compra verificada!
          </p>
          <p className="text-sm text-gray-600" data-id="element-14">
            <span className="font-semibold text-blue-600" data-id="element-15">
              {currentPurchase.name}
            </span>{' '}
            de {currentPurchase.city}
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-16">
            Compró Mega Pack Contabilidad hace unos minutos
          </p>
        </div>
      </div>
    </div>;
}